{
  "seed-bible": "Seed Bible",
  "allBooks": "All books",
  "new-testament": "New Testament",
  "old-testament": "Old Testament",
  "books": "Books",
  "search": "Search",
  "settings": "Settings",
  "side-menu": "Side menu",
  "copy-verse": "Copy",
  "next-chapter": "Next Chapter",
  "previous-chapter": "Previous Chapter",
  "share-verse": "Share",
  "share-session": "Share session",
  "cancel": "Cancel",
  "close": "Close",
  "open-settings": "Open Settings",
  "close-settings": "Close Settings",
  "session-settings": "Session settings",
  "shared-session-click-to-join": "is sharing — click to join",
  "dismiss": "Dismiss",
  "tabs": "Tabs",
  "new-tab": "New tab",
  "create-new-tab": "Create new tab",
  "tab-options": "Tab options",
  "open-tab-menu": "Open tab menu",
  "search-verses": "Search verses",
  "clear-search": "Clear search",
  "searching": "Searching...",
  "no-search-results": "No matching verses.",
  "open-chapter": "Open chapter",
  "account-settings": "Account settings",
  "account-settings-intro": "Manage your profile information here",
  "profile-picture": "Profile picture",
  "update-picture": "Update picture",
  "uploading": "Uploading...",
  "take-photo": "Take a photo",
  "choose-from-gallery": "Choose from gallery",
  "upload-from-device": "Upload from device",
  "crop-your-photo": "Crop your photo",
  "zoom": "Zoom",
  "set-picture": "Set picture",
  "profile-name": "Profile name",
  "profile-name-placeholder": "e.g Craig family",
  "profile-name-helper": "You can change this later",
  "description": "Description",
  "optional": "(Optional)",
  "description-placeholder": "Enter your profile description...",
  "location": "Location",
  "location-placeholder": "e.g Austin,TX",
  "your-id-is": "Your ID is:",
  "copy-user-id": "Copy user ID",
  "copied": "Copied",
  "copy": "Copy",
  "save-changes": "Save changes",
  "sign-out": "Sign out",
  "login-required-message": "Please log in to view and edit your profile.",
  "log-in": "Log in",
  "login-email-title": "Enter your email address",
  "login-sending": "Sending…",
  "login-code-title": "Enter the login code",
  "login-code-description": "We sent a login code to \"{{email}}\".",
  "login-code-placeholder": "Enter login code here",
  "login-change-email": "Change email address",
  "login-resend-code": "Resend code",
  "login-confirm-code": "Confirm code",
  "login-verifying": "Verifying…",
  "login-error-email-required": "Please enter your email address.",
  "login-error-code-required": "Please enter the code from your email.",
  "login-error-generic": "Something went wrong. Please try again.",
  "login-account-title": "Login to your account",
  "login-account-subtitle": "Enter the email address you want to login with",
  "login-agree-prefix": "I agree to the",
  "login-error-terms-required": "Please agree to the terms of service to continue.",
  "terms-of-service": "Terms of service",
  "privacy-policy": "Privacy policy",
  "code-of-conduct": "Code of conduct",
  "tanakh": "Tanakh",
  "traditional": "Traditional",
  "no-chapter-content-found": "No chapter content found.",
  "no-translations-available": "No translations available.",
  "more": "More",
  "themes": "Themes",
  "theme-light": "Light",
  "theme-dark": "Dark",
  "page-settings": "Page settings",
  "display-and-theme": "Display & Theme",
  "display-and-theme-description": "Pick a theme and tune how Scripture and the UI are displayed.",
  "scripture-settings": "Scripture settings",
  "scripture-elements": "Scripture elements",
  "scripture-settings-font-size-example": "A",
  "show-headings": "Show headings",
  "show-verse-numbers": "Show verse numbers",
  "show-footnotes": "Show footnotes",
  "show-highlights": "Show highlights",
  "show-red-lettering": "Show red lettering",
  "all-settings": "All settings",
  "download-settings": "Download settings",
  "downloading-settings": "Downloading settings...",
  "upload-settings": "Upload settings",
  "uploading-settings": "Uploading settings...",
  "no-extensions-available": "No extensions available.",
  "installed-extensions": "Installed",
  "available-extensions": "Available",
  "no-installed-extensions": "You haven't installed any extensions yet.",
  "no-available-extensions": "There are no more extensions available to install.",
  "extension-state-installed": "Installed",
  "extension-state-downloaded": "Downloaded",
  "extension-state-pending": "Installing…",
  "extension-state-none": "Not installed",
  "install": "Install",
  "uninstall": "Uninstall",
  "reset-toolbar": "Reset toolbar",
  "custom": "Custom",
  "text-section-bookTitle": "Book Title Text",
  "text-section-heading": "Heading Text",
  "text-section-verse": "Verse Text",
  "weight": "Weight",
  "bold": "Bold",
  "regular": "Regular",
  "light": "Light",
  "font": "Font",
  "margin-vertical": "Margin (vertical, px)",
  "margin-horizontal": "Margin (horizontal, px)",
  "reset-text-settings": "Reset text settings",
  "customize-colors": "Customize colors",
  "highlight-colors": "Highlight colors",
  "reset-all-custom-colors": "Reset all custom colors",
  "customize": "Customize",
  "create-customization": "Create Customization",
  "no-customizations": "You don't have any customizations yet. Create one to get started.",
  "customization-not-found": "This customization could not be found.",
  "customization-name": "Name",
  "customization-primaryColor": "Primary",
  "customization-primaryFontColor": "Primary text",
  "customization-secondaryColor": "Secondary",
  "customization-secondaryFontColor": "Secondary text",
  "customization-tertiaryColor": "Tertiary",
  "customization-fontColor": "Text",
  "customization-linkColor": "Link",
  "customization-linkVisitedColor": "Visited link",
  "customization-background": "App background",
  "customization-readerBackground": "Reader background",
  "customization-sidebarBackground": "Sidebar background",
  "customization-readerToolbarBackground": "Reader toolbar background",
  "customization-readerToolbarFloatingButtonBackground": "Floating button background",
  "customization-dividerColor": "Divider",
  "customization-readerFontColor": "Reader text",
  "customization-sidebarFontColor": "Sidebar text",
  "customization-bookTitleFontColor": "Book title",
  "customization-chapterHeadingFontColor": "Chapter heading",
  "customization-verseFontColor": "Verse",
  "customization-hebrewSubtitleFontColor": "Hebrew subtitle",
  "customization-readerToolbarFontColor": "Reader toolbar text",
  "customization-readerToolbarFloatingButtonFontColor": "Floating button text",
  "customization-selectedVerseTextDecorationColor": "Selected verse decoration",
  "customization-fonts": "Fonts",
  "customization-fontFamily": "Default",
  "customization-bookTitleFontFamily": "Book title",
  "customization-chapterHeadingFontFamily": "Chapter heading",
  "customization-verseFontFamily": "Verse",
  "customization-hebrewSubtitleFontFamily": "Hebrew subtitle",
  "custom-font-option": "Custom…",
  "custom-font-name-placeholder": "Google Font name",
  "delete-customization": "Delete",
  "confirm-delete-customization": "Confirm delete",
  "customization-link-copied": "Customization link copied to clipboard",
  "customization-saved": "Customization saved",
  "customization-options": "Customization options",
  "customization-extensions": "Extensions",
  "customization-extensions-description": "Choose how each extension behaves for anyone using this customization: available to install themselves, installed automatically with no prompt, or hidden from the extensions list entirely.",
  "extension-availability-available": "Available",
  "extension-availability-auto-installed": "Auto-installed",
  "extension-availability-hidden": "Hidden",
  "extensions-for-active-customization": "Showing extensions for {{name}}. Extensions this customization includes can't be removed here.",
  "variants": "Themes",
  "add-variant": "Add theme",
  "base-theme": "Base theme",
  "select-base-theme": "Base this theme on…",
  "base-theme-description": "Changes which preset this theme falls back to for anything you haven't customized. Your own edits are kept.",
  "reset-to-base-theme": "Reset to base theme",
  "low-contrast-warning": "{{label}}: contrast is only {{ratio}}:1 — aim for at least {{minRatio}}:1 so text stays readable.",
  "highlight-text-on-background": "{{label}} text on its background",
  "variant-name": "Name",
  "variant-not-found": "This theme could not be found.",
  "variant-options": "Theme options",
  "set-as-default-variant": "Set as default",
  "delete-variant": "Delete",
  "confirm-delete-variant": "Confirm delete",
  "default": "Default",
  "colors-controlled-by-customization": "Colors are controlled by the active Customization. Change which theme you're using from Display & Theme.",
  "go-to-display-and-theme": "Go to Display & Theme",
  "logo": "Logo",
  "upload-logo": "Upload logo",
  "remove-logo": "Remove logo",
  "crop-your-logo": "Crop your logo",
  "choose-image": "Choose an image",
  "set-logo": "Set logo",
  "book-order": "Book order",
  "selection-ui": "Selection UI",
  "show-selected-items": "Show selected items",
  "show-highlight-colors": "Show highlight colors",
  "show-icon-text": "Show icon text",
  "toolbar": "Toolbar",
  "extensions": "Extensions",
  "display": "Display",
  "theme-and-text": "Theme & text",
  "go-to-all-settings": "Go to all settings",
  "keep-screen-awake": "Keep screen awake",
  "language": "Language",
  "report-a-bug": "Report a bug",
  "session-settings-host-only_note": "Only the session host can change these settings.",
  "session-settings-host-only_navigate": "Only host can navigate",
  "session-settings-host-only_highlight": "Only host can highlight",
  "session-settings-highlight-duration": "Highlight for",
  "end-session": "End Session",
  "panels": "Panels",
  "open-in-new-panel": "Open in new panel",
  "close-sidebar": "Close sidebar",
  "select-pane-layout": "Select pane layout",
  "pane-layout": "Pane layout",
  "back": "Back",
  "selected": "Selected",
  "decrease-scripture-font-size": "Decrease scripture font size",
  "increase-scripture-font-size": "Increase scripture font size",
  "change-line-spacing": "Change line spacing",
  "line-spacing_lineHeight": "Line spacing: {{lineHeight}}",
  "toolbar_description": "Choose which reader toolbar tools appear and in what order.",
  "italic": "Italic",
  "underline": "Underline",
  "alignment_x": "Alignment: {{alignment}}",
  "change_alignment": "Change alignment",
  "pick_text_color": "Pick text color",
  "text_color": "Text color",
  "follow_theme": "Follow theme",
  "reset-to-default": "Reset to default",
  "id_highlight-text-color": "{{id}} highlight text color",
  "id_highlight-background-color": "{{id}} highlight background color",
  "all-settings-description": "Fine-tune every text section and customize each theme color.",
  "close-footnote": "Close footnote",
  "add-custom-color": "Add custom color",
  "add-color": "Add color",
  "clear-highlight": "Clear highlight",
  "clear": "Clear",
  "highlight": "Highlight",
  "highlight-selection": "Highlight selection",
  "shared-sessions": "Shared sessions",
  "search-translation": "Search translations...",
  "old-testament_short": "OT",
  "new-testament_short": "NT",
  "apocrypha": "Apocrypha",
  "custom-translations": "Custom translations",
  "no-translation-results-found": "No results found. Would you like to expand your search to include partially complete translations as well?",
  "show-all-translations": "Show all translations",
  "search-books": "Search books...",
  "no-results-found": "No results found.",
  "information-about-this-translation": "Information about this translation",
  "import": "Import",
  "enter-url": "Enter URL",
  "complete-translations": "Complete translations",
  "all-translations": "All translations",
  "popular-translations": "Popular translations",
  "apocrypha-info-text": "None of the writings in this section were ever considered Scripture by early Jewish or Christian communities. The Bible is a specific collection of books. Jews and Christians have always agreed on the Old Testament, which comes from a fixed set of sacred writings the Jewish people called the Tanakh and Christians call the Old Testament. The content of the Tanakh and the Old Testament are exactly the same, but are commonly arranged differently. Christians additionally recognize the New Testament, which tells the story of Jesus, his teachings, and the writings of his followers. The writings below were known and widely read at the time the Bible was written, but they were never treated as Scripture. While ancient authors sometimes quoted a wide range of texts including poets, philosophers, and other writings, quoting something is not the same as treating it as Scripture. These writings are included here for historical and literary reference only.",
  "1-psalms": "1 Psalms",
  "3-psalms": "3 Psalms",
  "4-psalms": "4 Psalms",
  "5-psalms": "5 Psalms",
  "chat": "Chat",
  "today": "Today",
  "you": "You",
  "bible": "Bible",
  "read-the-bible": "Read the Bible",
  "add-verse": "Add verse",
  "add": "Add",
  "category-options": "Folder options",
  "rename": "Rename",
  "delete": "Delete",
  "new-folder-placeholder": "Folder name",
  "tasks": "Tasks",
  "add-new-tab": "Add new tab",
  "folder-name-taken": "A folder with that name already exists.",
  "add-to-new": "Add to new",
  "save": "Save",
  "seed-bible-description": "Read {{bookName}} {{chapterNumber}} in the Seed Bible",
  "social-title": "Read {{bookName}} {{chapterNumber}}",
  "chapter-navigation": "Chapter navigation",
  "tutorial.skip": "Skip",
  "tutorial.back": "Back",
  "tutorial.done": "Done",
  "tutorial.next": "Next",
  "tutorial.stepProgress": "Step {{current}} of {{total}}",
  "tutorial.offlineDownloadTitle": "Tap to keep it on your device",
  "tutorial.offlineDownloadBody": "Any translation with this icon can be saved for offline reading.",
  "offlinePrompt.title": "Save {{abbreviation}} for offline reading?",
  "offlinePrompt.body": "Keep {{name}} on your device so you can read it without a connection. About {{size}}.",
  "offlinePrompt.bodyNoSize": "Keep {{name}} on your device so you can read it without a connection.",
  "offlinePrompt.save": "Save offline",
  "offlinePrompt.notNow": "Not now",
  "updatePrompt.title": "Update {{abbreviation}}?",
  "updatePrompt.body": "A newer version of {{name}} is available. Update your offline copy to keep it current.",
  "updatePrompt.update": "Update",
  "updatePrompt.notNow": "Not now",
  "tutorial.selectorBooksTitle": "Select books and chapters",
  "tutorial.selectorBooksBody": "Choose a chapter from here to begin reading.",
  "tutorial.selectorTranslationTitle": "Select a Bible text",
  "tutorial.selectorTranslationBody": "Choose from any of the available versions.",
  "tutorial.selectorTestamentTitle": "Filter book options",
  "tutorial.selectorTestamentBody": "Show all books, or narrow to just the Old Testament, New Testament, or extra-biblical writings.",
  "tutorial.selectorSearchTitle": "Search by",
  "tutorial.selectorSearchBody": "Search by chapter, verse or book from here.",
  "tutorial.tabsTitle": "Tabs and saves",
  "tutorial.tabsBody": "Your open passages and saves live here.",
  "tutorial.toolbarTitle": "Toolbar",
  "tutorial.toolbarBody": "You can customize the toolbar to your liking. By default, book selection, navigation, and search are built in.",
  "tutorial.settingsTitle": "Settings",
  "tutorial.settingsBody": "Customize themes, text, and more here, or install the app to your device.",
  "tutorial.mobilePassageTitle": "Your current translation",
  "tutorial.mobilePassageBody": "Tap the translation name to jump to a different translation.",
  "tutorial.mobileBooksTitle": "Your book/chapter selection",
  "tutorial.mobileBooksBody": "Tap the book name to jump to a different book or chapter.",
  "tutorial.mobileToolbarBody": "Switch between the Bible, search, and more from the bottom bar.",
  "tutorial.mobileSettingsTitle": "Settings",
  "tutorial.mobileSettingsBody": "Customize text, themes, and reading options here.",
  "tutorial.paneLayoutTitle": "Arrange your panes",
  "tutorial.paneLayoutBody": "Choose how many passages to read side by side from this layout menu.",
  "tutorial.addTabTitle": "Open more passages",
  "tutorial.addTabBody": "Add a new tab to read several books or translations side by side.",
  "tutorial.customizationNameTitle": "Name your site",
  "tutorial.customizationNameBody": "This name shows up in the browser tab, the header, and anywhere else your site is referenced. Change it any time.",
  "tutorial.customizationLogoTitle": "Add a logo",
  "tutorial.customizationLogoBody": "Upload an image to replace the default logo shown across your site.",
  "tutorial.customizationThemesTitle": "Themes",
  "tutorial.customizationThemesBody": "A theme controls all of your site's colors and fonts. Let's open one and see what you can change.",
  "tutorial.themeVariantNameTitle": "Name this theme",
  "tutorial.themeVariantNameBody": "Give each theme its own name so it's easy to tell them apart if you create more than one.",
  "tutorial.themeBaseTitle": "Base theme",
  "tutorial.themeBaseBody": "Every theme starts from a preset. Pick one here, then fine-tune individual colors below — your edits are kept even if you switch presets later.",
  "tutorial.themeBrandTitle": "Brand colors",
  "tutorial.themeBrandBody": "Your primary, secondary, and link colors — the colors that carry your site's identity.",
  "tutorial.themeSurfacesTitle": "Surfaces",
  "tutorial.themeSurfacesBody": "Backgrounds for the app, reader, sidebar, and toolbar.",
  "tutorial.themeTextTitle": "Text colors",
  "tutorial.themeTextBody": "Colors for body text, headings, verse numbers, and more.",
  "tutorial.themeSelectionTitle": "Verse selection",
  "tutorial.themeSelectionBody": "The color used to highlight a verse when it's selected.",
  "tutorial.themeFontsTitle": "Fonts",
  "tutorial.themeFontsBody": "Pick fonts for your default text, book titles, chapter headings, and verses — choose a preset or type in any Google Font name.",
  "tutorial.themeHighlightsTitle": "Highlight colors",
  "tutorial.themeHighlightsBody": "The colors readers can use to highlight verses — set a background and text color for each.",
  "onboarding.installTargetDesktop": "desktop",
  "onboarding.installTargetMobile": "home screen",
  "onboarding.installThanks": "Thanks for installing!",
  "onboarding.installMaybe": "Maybe next time!",
  "onboarding.installUnavailable": "PWA installation is not available",
  "onboarding.installBodyPre": "Add Seed Bible to your ",
  "onboarding.installBodyPost": " to return anytime. You can always find this option later in Settings.",
  "onboarding.iosStepsPre": "Tap ",
  "onboarding.iosStepsPost": " in the toolbar, then choose “Add to Home Screen”.",
  "onboarding.gotIt": "Got it",
  "onboarding.installApp": "Install App",
  "onboarding.maybeLater": "Maybe later",
  "install-app": "Install App",
  "launch-tutorial": "Launch tutorial",
  "search-languages": "Search languages...",
  "no-languages-found": "No languages found",
  "link-to-join-shared-session-copied": "A link to join the shared session was copied to your clipboard",
  "copied-translation-share-link": "Copied translation share link",
  "less": "Less",
  "swipe-up-more": "Swipe up to see more",
  "plans": "Plans",
  "reading-plans": "Reading plans",
  "create-reading-plan": "Create reading plan",
  "reading-plans-empty": "You don't have any reading plans yet. Create one to get started.",
  "friends-reading-plans": "Reading plans from your friends",
  "untitled-reading-plan": "Untitled plan",
  "reading-plan-description_placeholder": "What is this plan about?",
  "discover": "Discover",
  "playlists": "Playlists",
  "friends-playlists": "Playlists from your friends",
  "playlist-history": "Playlist history",
  "playlist-history-session-summary": "{{time}} - {{percent}}% complete - {{item}}",
  "playlist-history-session-summary-no-item": "{{time}} - {{percent}}% complete",
  "playlist-history-continue": "Continue",
  "playlist-history-replay": "Replay",
  "playlist-history-remove": "Remove from history",
  "playlist-history-options": "Playlist history options",
  "playlist-history-open-failed": "Couldn't open that playlist. It may have been deleted.",
  "yesterday": "Yesterday",
  "cross-references": "Cross references",
  "study-notes": "Study notes",
  "content": "Content",
  "untitled-playlist": "Untitled playlist",
  "discover-annotations-empty": "You don't have any notes for this chapter.",
  "discover-cross-references-empty": "No cross references for this chapter.",
  "discover-study-notes-empty": "No study notes for this chapter.",
  "discover-content-empty": "No content for this chapter.",
  "discover-choose-filter-hint": "Pick a filter above to see more from this chapter.",
  "discover-select-tab": "Select a tab to discover related material.",
  "create-playlist": "Create",
  "playlist-title_placeholder": "Playlist title",
  "playlist-description_placeholder": "What is this playlist about?",
  "read-more": "Read more",
  "read-less": "Read less",
  "items": "Items",
  "playlist-items-empty": "No items yet.",
  "playlist-item-html": "HTML snippet",
  "playlist-item-title-placeholder": "Title (optional)",
  "open-link": "Open",
  "add-to-playlist": "Add to playlist",
  "edit-playlist": "Edit playlist",
  "delete-playlist": "Delete",
  "playlist-options": "Playlist options",
  "delete-playlist-confirm-title": "Delete playlist?",
  "delete-playlist-confirm-message": "Delete \"{{title}}\"? This can't be undone.",
  "delete-playlist-failed": "Couldn't delete the playlist.",
  "remove-playlist-item": "Remove item",
  "edit-playlist-item": "Edit item",
  "playlist-add-item": "Add item",
  "playlist-edit-item": "Edit item",
  "playlist-save-item": "Save changes",
  "playlist-add-scripture-placeholder": "e.g. John 3 or John 3:16",
  "playlist-add-link-placeholder": "https://example.com",
  "playlist-add-button": "Add item",
  "playlist-add-scripture-error": "Couldn't find that reference",
  "playlist-add-link-error": "Enter a valid URL",
  "playlist-add-link-embed": "Embed this link",
  "play-playlist": "Play playlist",
  "stop": "Stop",
  "queue": "Queue",
  "previous": "Previous",
  "next": "Next",
  "editor-format-bold": "Bold",
  "editor-format-italic": "Italic",
  "editor-format-underline": "Underline",
  "editor-align-left": "Align left",
  "editor-align-center": "Align center",
  "editor-align-right": "Align right",
  "editor-align-justify": "Justify",
  "anonymous": "Anonymous",
  "no-chat-messages": "No messages yet",
  "start-conversation": "Start a conversation",
  "presence-one-is-here": "{{name}} is here",
  "presence-many-are-here": "{{count}} people are here",
  "unable-to-send-message": "Unable to send message.",
  "type-a-message": "Type a message...",
  "send-message": "Send message",
  "someone-is-typing": "Someone is typing...",
  "x-and-x-are-typing": "{{first}} and {{second}} are typing...",
  "x-is-typing": "{{name}} is typing...",
  "x-is-typing-and-more": "{{name}} and {{count}} others are typing...",
  "x-is-typing-and-more_one": "{{name}} and one other is typing...",
  "x-is-typing-and-more_other": "{{name}} and {{count}} others are typing...",
  "chat-x-joined": "{{name}} joined",
  "chat-x-and-x-joined": "{{first}} and {{second}} joined",
  "chat-x-and-count-joined": "{{name}} and {{count}} others joined",
  "chat-x-and-count-joined_one": "{{name}} and one other joined",
  "chat-x-and-count-joined_other": "{{name}} and {{count}} others joined",
  "session-chat-just-you": "In-session chat (Just You)",
  "you-have-no-chats": "You have no chats. Create one using the + button below.",
  "no-chat-providers": "No chat providers are available. Connect an AI or messaging provider to start chatting.",
  "color-emerald": "Emerald",
  "color-blue": "Blue",
  "color-pink": "Pink",
  "color-amber": "Amber",
  "color-violet": "Violet",
  "color-red": "Red",
  "color-green": "Green",
  "color-orange": "Orange",
  "color-cyan": "Cyan",
  "color-rose": "Rose",
  "color-purple": "Purple",
  "color-teal": "Teal",
  "animal-forest": "Forest",
  "animal-park": "Log",
  "animal-eco": "Leaf",
  "animal-pets": "Dog",
  "animal-cruelty_free": "Rabbit",
  "animal-local_cafe": "Coffee",
  "animal-local_florist": "Flower",
  "animal-grass": "Grass",
  "animal-potted_plant": "Plant",
  "animal-nature": "Tree",
  "visual-color-animal-anonymous": "{{color}} {{animal}} (Anonymous)",
  "participants": "Participants",
  "no-participants-match": "No participants match",
  "active": "Active",
  "inactive": "Inactive",
  "available": "Available",
  "everyone": "Everyone",
  "open-chat": "Open chat",
  "tutorial.promptTitle": "Welcome to Seed Bible. Would you like a tutorial?",
  "tutorial.promptBody": "A guided tour is available to help you learn the ins and outs of Seed Bible.",
  "tutorial.promptDecline": "No, thanks",
  "tutorial.promptAccept": "Take the tour",
  "tutorial.skipPromptTitle": "Turn off tutorials?",
  "tutorial.skipPromptBody": "You can turn tutorials back on later from Settings. Would you like to stop seeing them, or just skip this one?",
  "tutorial.skipPromptKeep": "Just this one",
  "tutorial.skipPromptDisable": "Turn off tutorials",
  "session-settings-section-navigation": "Navigation",
  "session-settings-section-sharing": "Sharing",
  "session-settings-section-participants": "Participants",
  "collapsed-tab-shared-label": "{{title}} — shared session, {{count}} present",
  "shared": "Shared",
  "host": "Host",
  "co-host": "Co-host",
  "make-co-host": "Make co-host",
  "remove-co-host": "Remove co-host",
  "session-settings-navigate-desc_host": "Only the host can change the passage for everyone.",
  "session-settings-navigate-desc_all": "Everyone in the session can change the passage.",
  "session-settings-highlight-desc_host": "Only the host can highlight for everyone.",
  "session-settings-highlight-desc_all": "Everyone in the session can highlight.",
  "session-settings-share-translation": "Share translation",
  "session-settings-share-translation-desc_shared": "Everyone reads the same translation. Changing it updates it for everyone.",
  "session-settings-share-translation-desc_unique": "Each person keeps their own translation. Changing yours won't affect others.",
  "session-close-confirm-title": "End session?",
  "session-close-confirm-message": "Closing this will end the session for everyone.",
  "appoint-co-host": "Appoint a co-host",
  "appoint-co-host-instructions": "Choose someone to keep the session running:",
  "end-session-for-everyone": "End session",
  "dont-show-again": "Don't show this again",
  "share-playlist": "Share playlist",
  "playlist-url-copied": "Playlist URL copied to clipboard",
  "current-playlist": "Current playlist",
  "playlist-add-mode-label": "Item type",
  "languageUnavailable.title": "Language Unavailable",
  "languageUnavailable.body": "We don't currently have a Bible translation for this language, but we do support {{fallback}}. Would you like to switch the Bible text to {{fallback}} instead?",
  "languageUnavailable.yesContinue": "Yes, Continue",
  "languageUnavailable.noGoBack": "No, Go back",
  "ask-to-switch-ui-language": "Offer to switch language with translation",
  "ui-size": "UI size",
  "book-not-found-title": "Book not found",
  "book-not-found-message": "We couldn't find that book in {{translationName}}.",
  "book-not-found-action": "Go to {{bookName}} {{chapterNumber}}",
  "chapter-meta-description": "{{bookName}} {{chapterNumber}} ({{translationName}}): {{excerpt}}",
  "app-meta-description": "Read, search, and study the Bible online. Free translations in many languages, with highlights, notes, bookmarks, and reading plans.",
  "loading-profile": "Loading your profile…",
  "saving": "Saving…",
  "app-version": "v{{version}} · {{commit}}",
  "download-translation-offline": "Download for offline use",
  "cancel-translation-download": "Downloading {{percent}}% — tap to cancel",
  "cancel-translation-download-unknown-size": "Downloading {{size}} so far — tap to cancel",
  "saving-translation-to-device": "Saving to this device… {{percent}}% — tap to cancel",
  "translation-available-offline": "Available offline ({{size}}) — tap to remove",
  "update-offline-translation": "A newer version is available — tap to update",
  "retry-translation-download": "Download failed ({{error}}) — tap to retry",
  "translation-downloaded": "{{name}} is now available offline",
  "translation-download-failed": "Couldn't download {{name}}.",
  "translation-updated": "{{name}} was updated",
  "translation-update-failed": "Couldn't update {{name}}.",
  "translation-removed-from-device": "{{name}} was removed from this device",
  "remove-offline-translation-title": "Remove download?",
  "remove-offline-translation-message": "Remove \"{{name}}\" from this device? You'll need a connection to read it again.",
  "remove-offline-translation-failed": "Couldn't remove the download.",
  "remove": "Remove",
  "drag-to-reorder-playlist-item": "Drag to reorder",
  "unsaved-item-confirm-title": "Unsaved item",
  "unsaved-item-confirm-message": "You've started adding an item that hasn't been added to the playlist yet. What would you like to do?",
  "discard-and-save": "Discard and save",
  "add-and-save": "Add and save",
  "share": "Share",
  "share-sheet-title": "Share",
  "share-link": "Share a link",
  "share-link-subtitle": "Copy to clipboard",
  "share-via": "Share via…",
  "share-via-subtitle": "Use your device share sheet",
  "start-share-session": "Start and share session",
  "start-share-session-subtitle": "Invite others to read along live",
  "share-current-session": "Share current session",
  "share-current-session-subtitle": "Copy a link to invite others to read along live",
  "signed-out-message": "You've been signed out. Please sign in again.",
  "account-suspended-message": "Your account has been suspended.",
  "loading-chapter": "Loading chapter…",
  "chapter-unavailable": "Chapter unavailable",
  "chapter-unavailable-description": "We were unable to load the data for this chapter. Please check your internet connection and try again.",
  "reload": "Reload",
  "loading-picture-editor": "Loading the picture editor…",
  "unnamed-user": "User {{id}}",
  "swipe-to-see-more": "Swipe to see more",
  "show-more-languages": "Show more languages",
  "translation-book-coverage": "{{included}} of {{total}} books",
  "showing-languages-count": "Showing {{shown}} of {{total}}",
  "create-reading-plan-wizard": "Create new plan",
  "edit-reading-plan": "Edit plan",
  "reading-plan-step-name-title": "Name your plan",
  "reading-plan-name-placeholder": "e.g. My Psalms Journey",
  "reading-plan-description-label": "Description (optional)",
  "reading-plan-step-scripture-title": "Select readings",
  "reading-plan-step-cadences-title": "Reading cadences",
  "reading-plan-step-cadences-hint": "Choose the reading paces you want to offer. Readers can always choose to go at their own pace instead.",
  "reading-plan-cadence-length": "Finishes in {{count}} days",
  "reading-plan-cadence-length_one": "Finishes in {{count}} day",
  "reading-plan-cadence-length_other": "Finishes in {{count}} days",
  "reading-plan-choose-pace": "How do you want to read it?",
  "reading-plan-pace-self": "At my own pace",
  "reading-plan-pace-self-description": "Read one session at a time, with no schedule",
  "reading-plan-sessions-hint": "Add the readings for each session — scripture, text, or a link",
  "reading-plan-session-label": "Session {{number}}",
  "reading-plan-session-reading-count": "{{count}} readings",
  "reading-plan-session-reading-count_one": "{{count}} reading",
  "reading-plan-session-reading-count_other": "{{count}} readings",
  "reading-plan-session-empty": "No readings yet in this session",
  "reading-plan-add-session": "Add session",
  "reading-plan-remove-session": "Remove session",
  "reading-plan-session-count-sessions": "{{count}} sessions",
  "reading-plan-session-count-sessions_one": "{{count}} session",
  "reading-plan-session-count-sessions_other": "{{count}} sessions",
  "reading-plan-session-short": "Session",
  "reading-plan-progress-sessions": "{{done}}/{{total}} sessions",
  "reading-plan-min-per-session": "~{{count}} min/session",
  "reading-plan-mark-session-complete": "Mark session {{day}} complete",
  "reading-plan-celebration-session-title": "Session {{day}} complete!",
  "reading-plan-next-session": "Next: Session {{day}} · {{readings}}",
  "reading-plan-drafts": "Drafts",
  "reading-plan-draft-summary": "Draft · {{count}} readings",
  "reading-plan-draft-summary_one": "Draft · {{count}} reading",
  "reading-plan-draft-summary_other": "Draft · {{count}} readings",
  "reading-plan-discard-draft": "Discard",
  "reading-plan-discard-draft-confirm": "Delete for good?",
  "reading-plan-draft-saving": "Saving…",
  "reading-plan-draft-saved": "Draft saved",
  "reading-plan-draft-save-failed": "Couldn't save draft",
  "reading-plan-scripture-remove": "Remove reading",
  "reading-plan-create-submit": "Create plan",
  "reading-plan-save-changes": "Save changes",
  "reading-plan-create-error": "Something went wrong creating your plan. Please try again.",
  "reading-plan-no-readings": "Add at least one reading to create the plan",
  "reading-plan-needs-name": "Give your plan a name to save it",
  "reading-plan-delete": "Delete",
  "reading-plan-delete-confirm": "Delete for good?",
  "view-plan": "View plan",
  "reading-plan-load-failed": "Couldn't load this plan. Please try again.",
  "loading": "Loading…",
  "reading-plan-not-started": "Not started",
  "reading-plan-start": "Start plan",
  "reading-plan-streak": "{{count}}-day streak",
  "reading-plan-mark-complete": "Mark as complete",
  "reading-plan-empty-sessions": "This plan doesn't have any readings yet.",
  "reading-plan-celebration-title": "Day {{day}} complete!",
  "reading-plan-complete-title": "Plan complete!",
  "reading-plan-celebration-subtitle": "Great work. Keep the momentum going.",
  "reading-plan-back-to-plan": "Back to plan",
  "reading-plan-duration-days": "{{count}} days",
  "reading-plan-started-on": "started {{date}}",
  "reading-plan-ends-on": "ends {{date}}",
  "reading-plan-progress-days": "{{done}}/{{total}} days",
  "reading-plan-min-per-day": "~{{count}} min/day",
  "reading-plan-day-short": "Day",
  "reading-plan-reading-read": "Read",
  "reading-plan-reading-mins": "~{{count}} min",
  "reading-plan-reading-chapters": "Chapters",
  "reading-plan-reading-chapters-done": "{{done}} of {{total}} chapters",
  "reading-plan-read-day": "Read",
  "reading-plan-reflect": "Reflect",
  "reading-plan-mark-day-complete": "Mark Day {{day}} complete",
  "reading-plan-finish-readings": "Finish all readings to complete the day",
  "reading-plan-today-eyebrow": "Today · Day {{day}}",
  "reading-plan-active": "Active",
  "reading-plan-completed": "Completed",
  "reading-plan-next": "Next: Day {{day}} · {{readings}}",
  "reading-plan-days-behind": "{{count}} days behind",
  "reading-plan-finished": "Finished {{date}}",
  "reading-plan-restart": "Restart",
  "add-to-reading-plan": "Add to plan",
  "reading-plan-untitled-reading": "Reading",
  "reading-plan-preview-reading": "Preview {{reading}}",
  "reading-plan-mark-reading-complete": "Mark reading complete",
  "reading-plan-link-video": "Video",
  "reading-belongs-to": "This reading belongs to",
  "reading-plan-mark-passage-complete": "Mark {{passage}} as read",
  "reading-plan-read-nudge-title": "Nice reading!",
  "reading-plan-read-nudge-toast": "Mark {{passage}} complete?",
  "reading-plan-nudge-later": "Not now",
  "ai": "AI",
  "ai-edit-playlist": "Edit playlist with AI",
  "ai-playlist-chat-prompt": "What do you want to add/change?",
  "chat-tool-used": "{{name}} used {{count}} tools",
  "chat-tool-used_one": "{{name}} used a tool",
  "chat-tool-used_other": "{{name}} used {{count}} tools",
  "ai-context-button-label": "Active AI context",
  "ai-context-tool-count": "{{count}} tools",
  "annotation-conflict-title": "This note changed in two places",
  "annotation-conflict-message": "You changed this note on this device, and it also changed somewhere else. Which do you want to keep?",
  "annotation-conflict-deleted-elsewhere": "You changed this note on this device, but it was deleted somewhere else.",
  "annotation-conflict-deleted-locally": "You deleted this note on this device, but it was changed somewhere else.",
  "annotation-conflict-progress": "1 of {{total}} notes to review",
  "annotation-conflict-yours": "Your version",
  "annotation-conflict-theirs": "The other version",
  "annotation-conflict-you-deleted": "You deleted this note.",
  "annotation-conflict-was-deleted": "This note was deleted.",
  "annotation-conflict-no-content": "No content.",
  "annotation-conflict-confirm": "Confirm",
  "annotation-conflict-resolve-failed": "Couldn't apply that choice. It'll be tried again.",
  "annotation-sync-failed": "Couldn't save a note to your account. It's still on this device.",
  "session-disconnected": "You lost connection to the session",
  "session-reconnected": "You rejoined the session",
  "session-host-disconnected": "The host disconnected from the session",
  "session-host-reconnected": "The host reconnected to the session",
  "session-host-left": "The host left — you were removed from the session",
  "create-menu": "Create",
  "create-annotation-menu-item": "Annotation",
  "create-playlist-menu-item": "Playlist",
  "annotate-title": "Annotate {{location}}",
  "annotation-options": "Annotation options",
  "edit-annotation": "Edit",
  "delete-annotation": "Delete",
  "delete-annotation-confirm-title": "Delete annotation?",
  "delete-annotation-confirm-message": "Delete this annotation? This can't be undone.",
  "delete-annotation-failed": "Couldn't delete the annotation.",
  "save-annotation-failed": "Couldn't save the annotation.",
  "annotation-group-expand": "Expand group",
  "annotation-group-collapse": "Collapse group",
  "annotation-override-banner": "Notes are being saved and loaded from your team's account.",
  "annotation-override-save-to-my-account": "Save to my account",
  "notes": "Notes",
  "note": "Note",
  "show-more-verse-actions": "Show more actions",
  "show-fewer-verse-actions": "Show fewer actions",
  "x-notes": "{{count}} notes",
  "x-notes_one": "{{count}} note",
  "x-notes_other": "{{count}} notes",
  "chapter-notes-count": "{{count}} notes for this chapter",
  "chapter-notes-count_one": "{{count}} note for this chapter",
  "chapter-notes-count_other": "{{count}} notes for this chapter",
  "create-folder": "Create folder",
  "all": "All",
  "none": "None",
  "view-more": "VIEW MORE",
  "today-bookmarks": "BOOKMARKS",
  "today-search-verses": "Search books, chapters, verses...",
  "anonymous-greeting": "Welcome!",
  "community": "COMMUNITY",
  "go-somewhere-new": "GO SOMEWHERE NEW",
  "greeting-afternoon": "Good afternoon!",
  "greeting-afternoon-named": "Good afternoon, {{name}}!",
  "greeting-evening": "Good evening!",
  "greeting-evening-named": "Good evening, {{name}}!",
  "greeting-morning": "Good morning!",
  "greeting-morning-named": "Good morning, {{name}}!",
  "greeting-night": "Good night!",
  "greeting-night-named": "Good night, {{name}}!",
  "last-48-hours": "Last 48 hours",
  "open-bible": "Open Bible",
  "take-a-tour": "Take a tour",
  "personal-greeting": "Welcome {{name}}",
  "resume-reading": "CONTINUE WHERE YOU LEFT OFF",
  "resume-reading-loading": "Loading your reading history…",
  "selected-year": "Year: {{year}}",
  "this-month": "This month",
  "notes-for-verse": "Notes for verse {{verse}}",
  "this-week": "This week",
  "profile": "Profile",
  "open-profile": "Open profile",
  "edit-profile": "Edit profile",
  "change-profile-picture": "Change profile picture",
  "profile-signed-out-message": "Sign in to keep your highlights, notes and plans on every device.",
  "my-reading-plans": "My reading plans",
  "all-plans": "All plans",
  "plan-day-of": "Day {{day}} of {{total}}",
  "no-active-reading-plan": "You haven't started a plan yet.",
  "your-content": "Your content",
  "your-content-subtitle": "Create and manage your content",
  "search-your-content": "Search your content",
  "search-placeholder": "Search...",
  "see-all": "See all",
  "annotations": "Annotations",
  "highlights": "Highlights",
  "verse": "Verse",
  "chapter": "Chapter",
  "edit": "Edit",
  "more-options": "More options",
  "loading-your-content": "Gathering your content…",
  "your-content-load-failed": "Your content couldn't be loaded.",
  "your-content-no-matches": "Nothing matches that search.",
  "your-content-empty": "Notes, highlights, saves and playlists you make will show up here.",
  "your-content-empty-annotations": "Notes you write will show up here.",
  "your-content-empty-highlights": "Verses you highlight will show up here.",
  "your-content-empty-playlists": "Playlists you create will show up here.",
  "try-again": "Try again",
  "recent-uploads": "Recent uploads",
  "configure-extension": "Configure",
  "configure-extension-defaults": "Configure default overrides",
  "extension-settings-title": "{{name}} settings",
  "extension-settings-defaults-title": "{{name}} default overrides",
  "no-extension-settings": "This extension has no configurable settings.",
  "extension-settings-save-failed": "Couldn't save your settings.",
  "extension-settings-login-required": "Please log in to configure this extension.",
  "setting-default-value": "Default value: {{value}}",
  "setting-no-default": "No default",
  "override-setting": "Override {{name}}",
  "override-setting-label": "Override",
  "setting-value-on": "On",
  "setting-value-off": "Off",
  "change-translation": "Change translation ({{name}})",
  "hero-image": "Cover image",
  "hero-image-hint": "Optional. Recommended size: 1024×768",
  "no-hero-image": "No image",
  "add-hero-image": "Add cover image",
  "change-hero-image": "Change cover image",
  "remove-hero-image": "Remove cover image",
  "upload-a-picture": "Upload a picture",
  "no-photos-yet": "No photos yet. Upload a picture to get started.",
  "set-hero-image": "Set cover image",
  "crop-hero-image": "Crop your image",
  "switch-language-title": "Switch language?",
  "switch-language-body": "Do you want to switch your language to {{nativeLanguageName}}?",
  "switch-language-confirm": "Switch",
  "switch-language-dismiss": "Don't Switch",
  "switch-language-never": "Never Ask Again",
  "unsaved-changes": "Unsaved changes",
  "unsaved-changes-message": "You have unsaved changes. What would you like to do?",
  "confirm": "Confirm",
  "save-and-exit": "Save & exit",
  "go-back": "Go back",
  "unsaved-changes-confirm-title": "Unsaved changes",
  "unsaved-changes-confirm-message": "You have unsaved changes to this customization. What would you like to do?",
  "keep-editing": "Keep editing",
  "discard-changes": "Discard changes",
  "save-and-leave": "Save and leave",
  "chat-ai-error": "Sorry, something went wrong generating a response ({{error}}).",
  "playlist-editor": "Playlist Editor",
  "annotations-pending-sync": "{{count}} change waiting to sync",
  "annotations-pending-sync-plural": "{{count}} changes waiting to sync",
  "annotation-comment-updated": "Updated {{date}}",
  "unread-mention": "Unread mention",
  "unread-messages": "Unread messages: {{count}}",
  "ask-ai": "Ask AI",
  "read-book-chapter-button": "Read {{bookName}} {{chapterNumber}}",
  "scripture-width": "Scripture Width",
  "decrease-scripture-width": "Decrease scripture width",
  "increase-scripture-width": "Increase scripture width",
  "discover-content-panel": "Discover content",
  "discover-book-title": "Discover {{book}}",
  "show-all": "Show All",
  "session-url": "Session URL",
  "color-hue": "Hue",
  "color-saturation": "Saturation and brightness",
  "hex-color": "Hex color",
  "adopt-device-content-title": "Sync device content?",
  "adopt-device-content-message": "This device is storing {{content}} that are not associated with any account. Do you want to add them to your account?",
  "adopt-device-content-kind-highlights": "highlights",
  "adopt-device-content-kind-notes": "notes",
  "adopt-device-content-kind-both": "highlights and notes",
  "adopt-device-content-add": "Add to account",
  "adopt-device-content-skip": "Don't add",
  "about-title": "About Seed Bible",
  "about-meta-description": "Seed Bible is a free Bible app built for reading Scripture together with your family, friends, and community — free forever, no ads or paywalls.",
  "about-intro-community": "Seed Bible is a Bible for building a life in Scripture with those you actually do life with; your family, your closest friends, your house church. We believe Christian faith is meant to be lived together, and we want Scripture to become part of the ordinary life you already share with the people closest to you.",
  "about-intro-free": "We also believe access to God's Word should stay simple and dependable. Seed Bible is free forever, with no ads, no paywall, and no gimmicks between you and Scripture.",
  "about-updates-before-release-notes": "We're constantly improving and adding new capabilities — check the ",
  "about-updates-release-notes-link": "latest release notes",
  "about-updates-between-links": " to see what's new, or explore the ",
  "about-updates-tutorials-link": "tutorials",
  "about-updates-after-tutorials": " to learn more.",
  "about-mission": "Seed Bible is built and maintained by AO Lab, a 501(c)(3) nonprofit. Please pray for this ministry you are part of, and consider supporting the work financially or joining the Discord community to contribute in whatever way you feel led!",
  "about-thank-you": "Thank you!",
  "about-signoff": "In Christ alone,",
  "about-team": "The AO Lab Team",
  "about-action-open-passage": "Open a passage",
  "about-action-donate": "Donate",
  "about-action-discord": "Join Discord",
  "scripture-width-unit": "ch",
  "remove-save": "Remove save",
  "save-chapter": "Save chapter",
  "save-folder-empty": "No saves here yet.",
  "save-options": "Save options",
  "saves": "Saves",
  "bookmark": "Bookmark",
  "hide-saves": "Hide saves",
  "show-saves": "Show saves",
  "save-verses": "Save",
  "new-save-folder": "New folder",
  "edit-save": "Edit save",
  "remove-save-from-all-folders": "Remove from all folders",
  "add-save-modal": "Add save",
  "bookmark-redesign-coming-soon": "Bookmark redesign coming soon",
  "annotation-saved": "Annotation saved",
  "save-annotation-shortcut": "Save (Ctrl+Enter)",
  "save-annotation-shortcut-mac": "Save (⌘+Enter)",
  "your-content-empty-saves": "Passages you save will show up here.",
  "share-reading-plan": "Share plan",
  "reading-plan-url-copied": "Reading plan URL copied to clipboard",
  "failed-to-load-reading-plan": "Failed to load reading plan",
  "theme-system": "System",
  "customization-default-translation": "Default translation",
  "customization-default-translation-none": "Seed Bible's default",
  "customization-default-translation-unavailable": "{{id}} (unavailable)",
  "filter-translations": "Filter translations",
  "discover-annotations-empty-create": "Create a note",
  "friends": "Friends",
  "friends-signed-out": "Sign in to add friends and see what they're reading.",
  "friends-empty": "No friends yet. Share your friend link, or add someone by their user ID.",
  "friends-row-subtitle-empty": "Add friends and see what they're reading",
  "friends-count": "{{count}} friend",
  "friends-count-plural": "{{count}} friends",
  "friend-requests-count": "{{count}} request",
  "friend-requests-count-plural": "{{count}} requests",
  "friend-requests": "Friend requests",
  "sent-friend-requests": "Sent requests",
  "add-friend": "Add a friend",
  "add-friend-placeholder": "Email or user ID",
  "add-friend-placeholder-id": "User ID",
  "add-friend-invalid-input": "Enter an email address or a user ID.",
  "add-friend-invalid-id": "That doesn't look like a user ID.",
  "send-friend-request": "Send request",
  "friend-request-sent": "Request sent. Send them the link so they can accept it.",
  "friend-request-already-sent": "You've already sent them a request.",
  "friend-request-accepted-theirs": "They'd already asked you, so you're now friends.",
  "friend-already-friends": "You're already friends.",
  "friend-request-self": "That's your own account.",
  "friend-request-user-not-found": "No account uses that email.",
  "friend-request-failed": "Couldn't send the request. Try again.",
  "copy-friend-request-link": "Copy link",
  "copy-failed": "Couldn't copy to your clipboard.",
  "your-user-id": "Your user ID",
  "accept": "Accept",
  "decline": "Decline",
  "friend-request-expired": "That request has expired.",
  "friend-request-unavailable": "That request is no longer available.",
  "friend-request-answer-failed": "Couldn't answer the request. Try again.",
  "friend-request-waiting": "Waiting for them to accept",
  "friend-request-cancel-failed": "Couldn't cancel the request. Try again.",
  "remove-friend-confirm-title": "Remove friend?",
  "remove-friend-confirm-message": "Remove {{name}} as a friend? You'll both stop seeing each other's reading.",
  "remove-friend-failed": "Couldn't remove the friend. Try again.",
  "your-friend-link-description": "Share your friend link. Anyone who opens it can send you a request.",
  "copy-your-friend-link": "Copy your friend link",
  "friend-request": "Friend request",
  "add-friend-link-sign-in": "Sign in to send {{name}} a friend request.",
  "add-friend-link-own": "This is your own friend link. Share it so people can send you a friend request.",
  "add-friend-link-no-account": "This friend link doesn't match anyone's account. Check that it was copied correctly.",
  "person-profile-empty": "This person hasn't set up their profile yet.",
  "person-profile-no-account": "We couldn't find anyone with this user ID. It may have been copied incorrectly.",
  "view-profile-of": "View {{name}}'s profile",
  "add-friend-link-already-friends": "You're already friends with {{name}}.",
  "add-friend-link-already-sent": "You've already sent {{name}} a friend request.",
  "add-friend-link-they-asked": "{{name}} has already sent you a friend request.",
  "add-friend-link-confirm": "Send {{name}} a friend request?",
  "friend-request-sent-to": "Friend request sent to {{name}}.",
  "now-friends-with": "You're now friends with {{name}}.",
  "friend-request-link-sign-in": "Sign in to see this friend request.",
  "friend-request-link-unavailable": "This friend request isn't available. It may have been sent to a different account, already been answered, or expired.",
  "friend-request-link-confirm": "{{name}} wants to be friends.",
  "friend-request-link-own": "This is the link to your friend request to {{name}}. Send it to them so they can accept.",
  "copy-your-user-id": "Copy your user ID",
  "add-friend-button": "Add friend",
  "friend-status-requested": "Requested",
  "add-friend-user": "Add {{name}} as a friend",
  "accept-friend-user": "Accept {{name}}'s friend request",
  "decline-friend-user": "Decline {{name}}'s friend request",
  "cancel-friend-request-user": "Cancel your friend request to {{name}}",
  "copy-friend-request-link-user": "Copy the link to your friend request to {{name}}",
  "remove-friend-user": "Remove {{name}} as a friend",
  "friend-request-sent-toast": "Friend request sent.",
  "friend-request-declined": "Declined {{name}}'s friend request.",
  "friend-request-canceled": "Canceled your friend request to {{name}}.",
  "open-in-new-tab": "Open in New Tab",
  "about-apocrypha": "About the Apocrypha",
  "shared-page-title": "{{title}} by {{author}}",
  "playlist-page-meta-description": "A Bible reading playlist on Seed Bible.",
  "shared-page-by-author": "By {{author}}",
  "playlist-page-item-count": "{{count}} items",
  "playlist-page-item-count_one": "{{count}} item",
  "playlist-page-item-count_other": "{{count}} items",
  "playlist-page-start": "Start Playlist",
  "reading-plan-page-meta-description": "A Bible reading plan on Seed Bible.",
  "reading-plan-page-start": "Start Reading Plan",
  "reading-plan-page-minutes-per-session": "About {{count}} min per session",
  "reading-plan-page-start-over": "Start from beginning",
  "reading-plan-page-finished": "You've finished this plan.",
  "reading-plan-page-on-day": "You're on day {{day}}",
  "reading-plan-page-on-session": "You're on session {{session}}",
  "reading-plan-page-resume-day": "Resume day {{day}}",
  "reading-plan-page-resume-session": "Resume session {{session}}",
  "reading-plan-not-found-title": "Reading plan not found",
  "reading-plan-load-failed-title": "Couldn't load reading plan",
  "reading-plan-load-failed-message": "Something went wrong loading this reading plan. Check your internet connection and try again.",
  "reading-plan-not-found-message": "This reading plan doesn't exist, or it has been deleted. Check the link, or ask the person who shared it for a new one.",
  "chapter-unavailable-offline-switch": "You have {{count}} translations saved on your device that contain {{bookName}} {{chapterNumber}}.",
  "chapter-unavailable-offline-switch_one": "You have a translation saved on your device that contains {{bookName}} {{chapterNumber}}.",
  "chapter-unavailable-offline-switch_other": "You have {{count}} translations saved on your device that contain {{bookName}} {{chapterNumber}}.",
  "chapter-unavailable-offline-switch-action": "Switch to {{name}}",
  "chapter-unavailable-offline-switch-choose": "Choose a saved translation",
  "chapter-unavailable-offline-switch-confirm": "Switch",
  "chapter-unavailable-offline-switch-empty": "No matching translations",
  "playlist-not-found-title": "Playlist not found",
  "playlist-not-found-message": "This playlist doesn't exist, or it has been deleted. Check the link, or ask the person who shared it for a new one.",
  "playlist-load-failed-title": "Couldn't load playlist",
  "playlist-load-failed-message": "Something went wrong loading this playlist. Check your internet connection and try again.",
  "playlist-url-copy-failed": "Couldn't copy the playlist link",
  "playlist-finished": "Playlist finished",
  "playlist-finished-message": "You've reached the end of {{title}}.",
  "annotation-editor-unavailable": "The formatting editor couldn't load, so this note will be saved as plain text.",
  "annotation-editor-unavailable-read-only": "The formatting editor couldn't load. This note has formatting that would be lost, so it can't be edited until you reconnect.",
  "annotation-text": "Annotation text"
}
